import { FunctionComponent } from 'preact';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import FavoriteIcon from '@material-ui/icons/Favorite';

// import MoreButton from '../../../../shared/MoreButton';
import styles from './../styles.module.scss';
import { clickedAd } from '../slice';
import { AdTile as AdTileType } from '../slice/types';

interface AdTileProps {
  onClickMore: () => void;
  index: number,
  item: AdTileType;
  isGlowing: boolean;
}

const AdTile: FunctionComponent<AdTileProps> = ({
  item,
  index,
  onClickMore,
  isGlowing,
}: AdTileProps) => {
  const dispatch = useDispatch();

  const separator = item.click_url.includes('?') ? '&' : '?';
  const click_url = item?.provider === 'adMarketplace' ? `${item.click_url}${separator}index=${index.toString()}` : item.click_url
  const adTile = { ...item, click_url }

  const onClick = (): void => {
    setTimeout(() => {
      dispatch(clickedAd(adTile));
    }, 1500)
  };

  return (
    <div
      className={cn(
        styles.topPageContainer,
        styles.topPageContainerAd,
        isGlowing ? styles.glow : ''
      )}
    >
      {/* <MoreButton className={styles.moreButton} onClick={onClickMore} /> */}
      <a className={styles.topPage} href={adTile.click_url} onClick={onClick}>
        <div className={cn(styles.hearts, styles.left)}>
          <FavoriteIcon />
          <FavoriteIcon />
          <FavoriteIcon />
          <FavoriteIcon />
        </div>
        <div
          className={cn(
            styles.icon,
            styles.adIcon
            // adTile.provider === 'zeropark' && styles.smallIcon
          )}
        >
          {adTile.image_url && <img src={adTile.image_url} alt="" />}
        </div>
        <span className={cn(styles.label, styles.adLabel)}>{adTile.title}</span>
        {adTile.title.toLowerCase().includes('ebay') ? (
          <span className={styles.adInfo}>Ad</span>
        ) : (
          ''
        )}
        <div className={cn(styles.hearts, styles.right)}>
          <FavoriteIcon />
          <FavoriteIcon />
          <FavoriteIcon />
          <FavoriteIcon />
        </div>
      </a>
    </div>
  );
};

export default AdTile;
